import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = {
  key: 0,
  class: "account-menu__list"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "account-menu__item" }

import { computed, ref } from "vue";
import { useAuth } from "@services/authentication";
import { getTranslations } from "@shared/Services/translations";
import { getBookingRouteUrl } from "@services/booking-route-service";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountMenu',
  props: {
    menuItems: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const { logout } = useAuth();
const translations = getTranslations();
const expanded = ref(false);

const availableMenuItems = computed(() =>
  props.menuItems.map((item) => ({
    ...item,
    href: getBookingRouteUrl(item.routeName),
  }))
);

function toggleExpanded(): void {
  expanded.value = !expanded.value;
}

function handleBlur(event: FocusEvent): void {
  const currentTarget = event.currentTarget;
  const relatedTarget = event.relatedTarget;

  if (!(currentTarget instanceof HTMLElement)) {
    expanded.value = false;
    return;
  }

  if (relatedTarget instanceof Node && currentTarget.contains(relatedTarget)) {
    return;
  }

  expanded.value = false;
}

function handleLogout(): void {
  expanded.value = false;
  logout();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "account-menu",
    onFocusout: handleBlur
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "account-menu__trigger",
      "aria-expanded": expanded.value,
      "aria-haspopup": "true",
      onClick: toggleExpanded
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "icon icon--captain account-menu__icon",
        "aria-hidden": "true"
      }, null, -1 /* CACHED */)),
      _createTextVNode(" " + _toDisplayString(_unref(translations)["bookings.header.myaccount"]), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_1),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableMenuItems.value, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.routeName,
              class: "account-menu__item"
            }, [
              _createElementVNode("a", {
                href: item.href,
                class: "account-menu__link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = false))
              }, _toDisplayString(item.linkText), 9 /* TEXT, PROPS */, _hoisted_3)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "account-menu__link",
              onClick: handleLogout
            }, _toDisplayString(_unref(translations)["bookings.header.logout"]), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 32 /* NEED_HYDRATION */))
}
}

})